export default "__VITE_ASSET__DVf$IjE5__"